import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgClock = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M7.5 3v5l2.5 2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={7.5} cy={7.5} r={7} stroke="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
